import { RouteObject } from "react-router";
import { REPORT_VIEW_PAGE } from "./const";
import ReportViewPage from "./ReportViewPage";

export default function createRoute(): RouteObject {
  return {
    path: REPORT_VIEW_PAGE,
    element: <ReportViewPage />,
  };
}
